import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Lookup, Pager, Paging, Selection } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppCol, AppLayoutTop, AppRow } from 'components/appComponents';
import $createStore from 'utils/create-store-instance';

import { MaterialInfo } from '../components/MaterialInfo';
import { CreateEditModal, DeleteModal } from './components';

const MaterialPage: FC = () => {
  const unitData: any = useMemo(() => {
    return $createStore('/v1/unit', 'id');
  }, []);

  const [materialId, setMaterialId] = useState<number | null>(null);
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const requestDateSource = useMemo(() => {
    return $createStore('/v1/Material', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => {
    refGrid.current?.instance.refresh();
  };

  const onSelectionChangedHandler = ({ selectedRowsData }: any) => {
    const data = selectedRowsData[0];
    setMaterialId(data && data.id);
  };

  return (
    <div className="container-dev">
      <div className="reccpe-page">
        <AppCard>
          <AppRow>
            <AppCol col={8} className="pr-3 pl-2 reccpe-page__left">
              <>
                <AppLayoutTop title="Материалы">
                  <Button
                    width={120}
                    text="Создать"
                    type="default"
                    onClick={() => {
                      setDetailId(null);
                      setModalIsVisible(true);
                    }}
                  />
                </AppLayoutTop>

                {modalIsVisible && (
                  <CreateEditModal
                    changeVisible={setModalIsVisible}
                    id={detailId}
                    refresh={refresh}
                    visible={modalIsVisible}
                  />
                )}

                {modalIsVisibleDelete && (
                  <DeleteModal
                    changeVisible={setModalIsVisibleDelete}
                    visible={modalIsVisibleDelete}
                    refresh={refresh}
                    detailId={detailId}
                  />
                )}

                <DataGrid
                  dataSource={requestDateSource as any}
                  showBorders={false}
                  loadPanel={{
                    enabled: true,
                    text: 'Загрузка',
                  }}
                  ref={refGrid}
                  remoteOperations={true}
                  onSelectionChanged={onSelectionChangedHandler}
                >
                  <FilterRow visible={true} />
                  <Selection mode="single" />

                  <Column dataField="name" caption="Наименование" sortOrder="asc" />
                  <Column dataField="registerIncome" caption="Учет прихода" />
                  <Column dataField="isOverPayment" caption="Переплата за доставку" />

                  <Column dataField="unitId" caption="Ед .изм." width={100}>
                    <Lookup dataSource={unitData} valueExpr="id" displayExpr="name" />
                  </Column>
                  <Column dataField="comment" caption="Комментарий" width={200} visible={false} />

                  <Column
                    dataField="actions"
                    caption=""
                    width={120}
                    allowFiltering={false}
                    allowSorting={false}
                    cellRender={(data) => (
                      <>
                        <Button
                          icon="edit"
                          type="default"
                          stylingMode="text"
                          onClick={() => {
                            setDetailId(data.data.id);
                            setModalIsVisible(true);
                          }}
                        />

                        <Button
                          icon="trash"
                          type="default"
                          stylingMode="text"
                          onClick={() => {
                            setDetailId(data.data.id);
                            setModalIsVisibleDelete(true);
                          }}
                        />
                      </>
                    )}
                  />

                  <Paging defaultPageSize={15} />
                  <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
                </DataGrid>
              </>
            </AppCol>
            <AppCol col={4} className="reccpe-page__right pr-3">
              {materialId && <MaterialInfo materialId={materialId} />}
            </AppCol>
          </AppRow>
        </AppCard>
      </div>
    </div>
  );
};

export default MaterialPage;
